import { render, staticRenderFns } from "./QuotationBill.vue?vue&type=template&id=a2ee45a4&scoped=true&"
import script from "./QuotationBill.vue?vue&type=script&lang=js&"
export * from "./QuotationBill.vue?vue&type=script&lang=js&"
import style0 from "./QuotationBill.vue?vue&type=style&index=0&id=a2ee45a4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a2ee45a4",
  null
  
)

export default component.exports